import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
    "inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
    {
        variants: {
            variant: {
                default: "bg-zinc-900 text-white shadow-sm shadow-black/5 hover:bg-zinc-800",
                destructive:
                    "bg-red-500 text-white shadow-sm shadow-black/5 hover:bg-red-600",
                outline:
                    "border border-white/10 bg-transparent shadow-sm shadow-black/5 hover:bg-white/5 hover:text-white",
                secondary:
                    "bg-white/5 text-white shadow-sm shadow-black/5 hover:bg-white/10",
                ghost: "hover:bg-white/10 hover:text-white",
                link: "text-primary-400 underline-offset-4 hover:underline",
                glass: "glass-card border-white/10 hover:bg-white/5 text-white",
            },
            size: {
                default: "h-9 px-4 py-2",
                sm: "h-8 rounded-full px-3 text-xs",
                lg: "h-10 rounded-full px-8",
                icon: "h-9 w-9",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    },
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
        <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
    );
},
);
Button.displayName = "Button";

export { Button, buttonVariants };
